module.exports = __webpack_public_path__ + "ClinicaPro-Regular-webfont.bc258974615b6a41f8e7.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/ClinicaPro-Regular-webfont.woff
// module id = ../../../../../src/assets/fonts/ClinicaPro-Regular-webfont.woff
// module chunks = styles